import { useMemo } from 'react';
import _ from 'lodash';

import { UploadedFile, UppyFileMeta, useUppy } from '@lyearn/shared/hooks/useUppy';

export type FileType = UploadedFile<UppyFileMeta & { shortId: string }> & { url?: string };

const useUpload = (updateEditorState: (file: FileType) => void, nodeId: string) => {
  const { uppy, files, clearAll, removeFile } = useUppy<FileType>({
    onUploadSuccess: (file) => {
      if (file.meta.shortId === nodeId) {
        updateEditorState(file);
      }
      return Promise.resolve(file);
    },
    referenceId: 'editor-upload',
  });

  let currentFile = useMemo(
    () => _.find(files, (file) => file.meta.shortId === nodeId),
    [files, nodeId],
  );

  if (currentFile && !Number.isInteger(currentFile.fileProgress)) {
    removeFile(currentFile);
    currentFile = undefined;
  }
  return { uppy, currentFile, clearAll };
};

export default useUpload;
